import { RootState } from 'redux/reducers';
import { EtlState } from './handlers';

export const settingsForPostSelector = (state: RootState): any => state.etl.settingsForPost;
export const allSettingsSelector = (state: RootState): any => state.etl.allSettings;
export const pageNumberSelector = (state: RootState): number => state.etl.pageNumber;
export const transformationSelector = (state: RootState): any => state.etl.transformation;
export const resultDataSelector = (state: RootState): any => state.etl.importData;
export const selectedTemplateSelector = (state: RootState): any => state.etl.selectedTemplate;
